import React from 'react';
import { Badge, tokens } from '@fluentui/react-components';
import { ProjectStatus } from '../services/projectService';

// Project-level status badge. Shared by the Projects list and ProjectDetails so
// the status vocabulary lives in one place.
//
// Terminal states (canceled) render as a white-fill / neutral-stroke outline
// pill — the same treatment OrderStatusPill gives canceled/archived orders — so
// a closed-out project doesn't read as the same gray fill as an active Draft.
const STATUS_META: Record<ProjectStatus, { label: string; color: 'subtle' | 'informative' | 'success' }> = {
  draft: { label: 'Draft', color: 'subtle' },
  active: { label: 'Active', color: 'informative' },
  completed: { label: 'Completed', color: 'success' },
  canceled: { label: 'Canceled', color: 'subtle' },
};

interface ProjectStatusBadgeProps {
  status: ProjectStatus;
}

const ProjectStatusBadge: React.FC<ProjectStatusBadgeProps> = ({ status }) => {
  const meta = STATUS_META[status];
  if (status === 'canceled') {
    return (
      <Badge
        appearance="outline"
        style={{
          backgroundColor: tokens.colorNeutralBackground1,
          color: tokens.colorNeutralForeground1,
          borderColor: tokens.colorNeutralStroke1,
        }}
      >
        {meta.label}
      </Badge>
    );
  }
  return (
    <Badge appearance="filled" color={meta.color}>
      {meta.label}
    </Badge>
  );
};

export default ProjectStatusBadge;
